<!--
 * @Author: your name
 * @Date: 2022-03-13 02:58:15
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-24 14:55:39
 * @Description: file content
-->
<template>
  <div class="top">
    <TopBar :isTurntable="false"></TopBar>
    <div class="table-wheel">
      <LotteryCircle
        v-bind="$store.state.lottery.circleOptions"
        @circleClick="circleClickCallback"
      ></LotteryCircle>
    </div>

    <van-overlay
      :show="
        $store.state.lottery.prized && !$store.state.lottery.prizer.verified
      "
      z-index="999"
      lock-scroll
    >
      <div class="wrapper" @click.stop>
        <Modal
          @prize_get="get_prize"
          :prize="$store.state.lottery.prizeModalInfo"
        ></Modal>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import Modal from "../../components/Modal";
  import LotteryCircle from "../../components/LotteryCircle";
  import TopBar from "../../components/TopBar.vue";
  import { joinLuckyDraw } from "@/api/lotteryLucky";
  export default {
    components: {
      LotteryCircle,
      TopBar,
      Modal,
    },
    methods: {
      circleClickCallback(event) {
        if (this.$store.state.lottery.joinStatus === false) {
          joinLuckyDraw({
            // luckyAwardId: "9ae2573f-ab22-430c-8699-7cbb89850d68",
            // luckyAwardId: "9ae2573f-ab22-430c-8699-7cbb89850d68",
            // luckyAwardId: "a41a50a8-046b-4f3c-a3ff-1c0f4dd873e0",
            luckyAwardId: this.$route.query.luckyAwardId,
          })
            .then((res) => {
              console.log(res);
              this.$store.commit("lottery/OPTION_WAIT_OPEN_PRIZE");
              // 两秒之后自动刷新
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }
      },
      get_prize(event) {
        //  根据不同的抽奖类型，调用不同的接口
        // goods 前往下单
        // red_packet 暂时不知道前往哪里
        console.group(
          "%c 立即获取奖品，跳转下单",
          "color: #f00; font-size: 20px;"
        );
        console.log(
          "recordId",
          this.$store.state.lottery.prizer.awardGoodsRecordId
        );
        this.$router.push({
          name: "Settle",
          params: { fid: 0 },
          query: {
            awardId: this.$store.state.lottery.prizer.awardGoodsRecordId,
          },
        });
        console.groupEnd();
      },
    },
  };
</script>

<style lang="less" scoped>
  @import "../../var";
  .top {
    .center();
    .flex-column();
    .table-wheel {
      margin: 0 auto;
      box-sizing: border-box;
      position: relative;
      top: -@top-bar-height*2;
      .center();
      .flex-column();
    }
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .center();
      .get-button {
        position: absolute;
        top: 30%;
        z-index: 999;
      }
    }
  }
</style>
